class StepsComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addListeners();
  }

  /*
   * Adds click event listeners to next and previous buttons for step navigation.
   */
  addListeners() {
    this.previousButtons.forEach(button => button.addEventListener('click', () => this.changeStep(button, "prev")));
    this.nextButtons.forEach(button => button.addEventListener('click', () => this.changeStep(button)));

    subscribe(PUB_SUB_EVENTS.accordionOpened, ({ element }) => this.toggleImages(element));
  }

  /*
   * Changes the current step based on the clicked button and direction.
   * @param {Element} button - The button that was clicked to trigger the step change.
   * @param {string} direction - The direction of the step change, either "next" or "prev". Defaults to "next".
   */
  changeStep(button, direction = "next") {
    const step = button.closest("[data-step]");
    const stepIndex = parseInt(step.dataset.step);
    const targetStepIndex = direction === "next" ? stepIndex + 1 : stepIndex - 1;
    const targetStep = this.querySelector(`[data-step="${targetStepIndex}"]`);
    const stepTrigger = targetStep.querySelector("[data-step-trigger]");

    publish(PUB_SUB_EVENTS.toggleAccordion, { item: targetStep, button: stepTrigger });
  }

  /*
   * Toggles background and overlay images based on the current step and screen size.
   * @param {Element} step - The current step element to determine which images to show.
   */
  toggleImages(step) {
    const isMobile = window.matchMedia("(max-width: 749px)").matches;
    const mobileBackground = step.dataset.backgroundImageMobile;
    const desktopBackground = step.dataset.backgroundImage;
    const overlayImage = step.dataset.overlayImage;
    const overlayIcon = step.dataset.overlayIcon;

    if (this.overlayImage && overlayImage) this.updateImage(this.overlayImage, overlayImage);
    if (this.overlayIcon && overlayIcon) this.updateImage(this.overlayIcon, overlayIcon);

    if (isMobile && mobileBackground) {
      this.updateImage(this.backgroundImageMobile, mobileBackground);
    } else if (desktopBackground) {
      this.updateImage(this.backgroundImage, desktopBackground);
    }
  }

  /*
   * Updates an img element and its parent picture source elements.
   * @param {Element} img - The img element to update.
   * @param {string} src - The new image src.
   */
  updateImage(img, src) {
    if (!img) return;

    img.src = src;

    const picture = img.closest("[data-picture]");

    if (!picture) return;

    picture.querySelectorAll("source").forEach(source => {
      source.srcset = src;
    });
  }

  /*
   * Returns all step elements.
   */
  get steps() {
    return this.querySelectorAll("[data-step]");
  }

  /*
   * Returns all next step buttons.
   */
  get nextButtons() {
    return this.querySelectorAll("[data-step-next]");
  }

  /*
   * Returns all previous step buttons.
   */
  get previousButtons() {
    return this.querySelectorAll("[data-step-previous]");
  }

  /*
   * Returns the background image element.
   */
  get backgroundImage() {
    return this.querySelector("[data-background] [data-media-img]");
  }

  /*
   * Returns the mobile background image element.
   */
  get backgroundImageMobile() {
    return this.querySelector("[data-background] [data-media-img-mobile]");
  }

  /*
   * Returns the overlay image element.
   */
  get overlayImage() {
    return this.querySelector("[data-overlay-images] [data-overlay-image] [data-media-img]");
  }

  /*
   * Returns the overlay icon element.
   */
  get overlayIcon() {
    return this.querySelector("[data-overlay-images] [data-overlay-icon] [data-media-img]");
  }
}

customElements.define('steps-component', StepsComponent);